import { render, staticRenderFns } from "./EntryComponent.vue?vue&type=template&id=0b2a455e&"
import script from "./EntryComponent.vue?vue&type=script&lang=ts&"
export * from "./EntryComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports